import { LAYER_TYPES } from 'shared/stores/annotations';

export const copyTool = {
  install (toolbox) {
    return toolbox.extend('copy', {
      action (event) {
        this.USCOPE.uScope.startCopyMoveRegion(event, 'copy');
      },

      isEnabledDelegate () {
        // Do not copy report layers
        const result = this.ANNOTATIONS.selectedRegionLayer && this.ANNOTATIONS.selectedRegionLayer.type !== LAYER_TYPES.REPORT;
        return {and: result};
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/annotations/annotations-ui/tools/copy.js